import { schema } from "normalizr";

export const v2AssessmentSchema = new schema.Entity("assessments");
